import { ILedgerOperation } from './response.types'

// Ключ строки списка. Ledger различает строки ещё номером ревизии и её
// поколением, но в ответ они не входят: Сторно и Доначисление одной транзакции
// совпадают по кошельку, тикету и транзакции и различаются типом или временем.
// Повтор на странице получает суффикс по порядку — ключ уникален, а состояние
// строки не переезжает на соседнюю, как было бы с индексом. Это не
// идентификатор операции: адресовать по нему операцию нельзя.
export const operationRowKeys = (operations: ILedgerOperation[]): string[] => {
  const seen = new Map<string, number>()
  return operations.map((op) => {
    const key = `${op.walletId}-${op.ticketId}-${op.transactionId}-${op.kind}-${op.startedAt}`
    const n = (seen.get(key) ?? 0) + 1
    seen.set(key, n)
    return n === 1 ? key : `${key}#${n}`
  })
}
